import {RestResource} from "../rest";
import {ASSESSMENT_SERVER} from "../server";
import {athubAxios} from "../../util/athub-axios";

const assessmentRecord = new RestResource({server: ASSESSMENT_SERVER, resource: 'assessmentRecord'});

assessmentRecord.batchUpdate = (assessmentRecords) => {
    let url = `${ASSESSMENT_SERVER}/assessmentRecord/batch`;
    return new Promise((resolve, reject) => {
        athubAxios.put(url, assessmentRecords).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default assessmentRecord;